<template>
  <div class="container">
    <div class="row">
      <v-date-picker @click.stop.prevent="" v-model.lazy="orderDate" is-range :locale="datePickerLocale">
      </v-date-picker>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { createPopper } from '@popperjs/core'

const pageSlotsAmount = 5;

export default {
  name: 'Calendar',
  props: ['page'],
  data() {
    return {
      placement: 'bottom',
      filter: {
        page: 1,
        perPage: 10,
        search: undefined,
        status: []
      },
      orderDate: {
        // start: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        // end  : new Date()
      },
      sortBy: 'time',
      items: [],
      total: 0,
      callStatusList: [
        { label: 'Новый', value: 'Новый', c: 'new' },
        { label: 'Обработан', value: 'Обработан', c: 'success' },
        { label: 'На паузе', value: 'На паузе', c: 'pause' }
      ]
    }
  },
  mounted() {
    // window.$('.select-custom').selectpicker();
    this.getItems();
  },
  beforeUnmount() {
    // window.$('.landing-page select.select-custom').selectpicker('destroy');
    // window.$('.landing-page select.select-custom option.bs-title-option').remove();
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.filter.perPage)
    },
    statusSearch() {
      return this.filter.status
    },
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },
    pageAmount() {
      return Math.max(Math.ceil(this.total / this.filter.perPage), 1);
    },
    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    datePickerLocale() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },
  methods: {
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            },
          },
        ],
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy()
    },
    onChangeStatus(event, item) {
      // console.log(event, item)
      api.put('/api/callback', { id: item.id, status: event.value })
    },
    getItems() {
      let filer = Object.assign({}, this.filter);
      if (this.orderDate && this.orderDate.start && this.orderDate.end) {
        filer = Object.assign(filer, {
          created_at: [
            this.orderDate.start.getTime() / 1000 | 0,
            this.orderDate.end.getTime() / 1000 | 0
          ]
        });
        filer.created_at[0] = filer.created_at[0] - filer.created_at[0] % 86400;
        filer.created_at[1] = (filer.created_at[1] - filer.created_at[1] % 86400) + 86400;
      }
      api.post('/api/callback', { filter: filer, sortBy: this.sortBy }).then(response => response.data).then(
        data => {
          this.items = data.result.map(i => {
            i.created_at = new Date(i.created_at);
            i.updated_at = new Date(i.updated_at);

            return i
          });
          this.filter.page = data.page;
          this.total = data.total;
        })
    }
  },
  watch: {
    page(val) {
      this.filter.page = val;
      this.getItems()
    },
    statusSearch(val) {
      this.getItems()
    },
    orderDate() {
      this.getItems()
    }
  }
}
</script>

<style scoped></style>